<div [class]="customClasses().formGroup">
    <div class="form-check">
        <input
            class="form-check-input"
            [class]="customClasses()?.input"
            [class.is-invalid]="ngControl.touched && ngControl.invalid"
            type="{{ type }}"
            [formControl]="ngControl.control | formControl"
            [checked]="checked()"
            [attr.data-qa]="testAutomationSelectorName()"
            (change)="handleCheckboxChange($event)"
        />
        <label class="form-check-label" [class]="customClasses().label" [class.disabled]="ngControl.disabled">
            {{ label() }}
        </label>
    </div>

    @if (ngControl.control?.errors?.['required']) {
        <div class="invalid-feedback d-block">Please check the {{ label() | lowercase }}</div>
    }
</div>
